module.exports = __webpack_public_path__ + "img/second.922fc226.png";